export default [{
	path: '/tool',
	component: () => import('../views/tool/home'),
	children: [{
			path: 'text_To_audio',
			component: () => import('../views/tool/audio_tts/text_To_audio'),
			meta: {
				title: '文字转语音'
			}
		},
		{
			path: 'volcengine',
			component: () => import('../views/tool/audio_tts/volcengine'),
			meta: {
				title: '文字转语音'
			}
		},
		{
			path: 'photoSphereViewer',
			component: () => import('../views/tool/other_tools/photoSphereViewer'),
			meta: {
				title: '全景图在线预览'
			}
		},
		{
			path: 'qrcode',
			component: () => import('../views/tool/other_tools/qrcode'),
			meta: {
				title: '二维码生成'
			}
		}, {
			path: 'stepManage',
			component: () => import('../views/tool/data_center/stepManage')
		}, {
			path: 'practiceSelect',
			component: () => import('../views/tool/data_center/practiceSelect')
		}, {
			path: 'practiceAddLog',
			component: () => import('../views/tool/data_center/practiceAddLog')
		}, {
			path: 'practiceAddLog_1_x',
			component: () => import('../views/tool/data_center/practiceAddLog_1_x')
		}, {
			path: 'resourceSelect',
			component: () => import('../views/tool/data_center/resourceSelect')
		}, {
			path: 'resourceAddLog',
			component: () => import('../views/tool/data_center/resourceAddLog')
		}, {
			path: 'questionSelect',
			component: () => import('../views/tool/data_center/questionSelect')
		}, {
			path: 'questionAddLog',
			component: () => import('../views/tool/data_center/questionAddLog')
		}, {
			path: 'logUserLogin',
			component: () => import('../views/tool/data_center/logUserLogin.vue')
		}, {
			path: 'viewCourse',
			component: () => import('../views/tool/data_center/viewCourse.vue')
		}, {
			path: 'apiDoc',
			component: () => import('../views/tool/api_doc/index')
		},
		// 更新说明：目录来自 public/updates/index.json（scripts/update-notes-index.mjs 生成），不进数据库
		{
			path: 'updateNotes',
			component: () => import('../views/tool/update_notes/index'),
			meta: {
				title: '更新说明'
			}
		}
	]
}, {
	path: '/doc/preview',
	component: () => import('../views/tool/api_doc/publicPreview'),
	meta: {
		title: '文档预览'
	}
}, {
	path: '/caseCreate',
	component: () => import('../sys/resource-center/caseCreate.vue')
}]
